<template>

    <div class="agent-member-main-menu w-100">

        <form id="impersonateForm" method="POST" action="/admin/login-user" style="display: none;">
            <input type="hidden" name="member_id" />
        </form>

        <agent-member-transaction-history-component ref="memberTransactionHistory" :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" :api_token="this.$props.api_token">
        </agent-member-transaction-history-component>


        <agent-calendar-reservation-component ref="agentCalendarReservation" :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" :api_token="this.$props.api_token">
        </agent-calendar-reservation-component>

        <agent-fix-reserve-component ref="agentFixReserve" :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" :api_token="this.$props.api_token">
        </agent-fix-reserve-component>


        <AgentBuyCreditComponent ref="agentBuyCredits" 
            :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" 
            :api_token="this.$props.api_token"
            @get-agent-credit="updateAccountInfo">
        </AgentBuyCreditComponent>


        <WritingReportCardComponent ref="writingReportCard" 
            :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" 
            :api_token="this.$props.api_token">
        </WritingReportCardComponent>

        <ReportCardComponent ref="reportCard" 
            :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" 
            :api_token="this.$props.api_token">
        </ReportCardComponent>

        <AgentMemberUpdateComponent
            ref="agentMemberUpdate"  
            :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" 
            :api_token="this.$props.api_token"
            @update-member="onMemberUpdate"
        >
        </AgentMemberUpdateComponent>


        <AgentMemberViewerComponent
            ref="agentMemberViewer"  
            :agent_info="this.$props.agent_info"
            :agent_user_id="this.$props.agent_user_id" 
            :api_token="this.$props.api_token"
        >
        </AgentMemberViewerComponent>        


        <!--[START] AGENT ACCOUNT INFORMATION -->
        <div class="card agent-info-card border-0 shadow-sm">
            <div class="card-header agent-info-card-header text-white">
                スクールアカウント情報
            </div>
            <div class="card-body agent-info-card-body text-left">
                <div class="agent-info-grid">
                    <div class="agent-info-label">スクールアカウント</div>
                    <div class="agent-info-value">{{ this.$props.firstname }}</div>

                    <div class="agent-info-label">スクールアカウントID</div>
                    <div class="agent-info-value">{{ this.agent_info.agent_id }}</div>

                    <div class="agent-info-label">保有ポイント</div>
                    <div class="agent-info-value agent-info-credits" id="total_credits">{{ this.account.credits }}</div>

                    <div class="agent-info-label">最終購入日</div>
                    <div class="agent-info-value agent-info-muted">{{ this.account.dateOfPurchase }}</div>

                    <div class="agent-info-label">ポイント有効期限</div>
                    <div class="agent-info-value agent-info-muted">{{ this.account.creditsExpiration }}</div>
                </div>

                <p class="agent-info-description text-muted small mb-0 mt-3">
                    このポイントは、スクールアカウントの保有ポイントです。受講生にポイントを付与すると、この残高から差し引かれます。
                </p>
            </div>
        </div>
        <!--[END] AGENT ACCOUNT INFORMATION -->



        <!-- !! MEMBERS LIST MODAL !! -->
        <b-modal id="openAgentMemberList" title="受講生一覧" ok-only ok-title="閉じる"
            @ok="handleModalMemberListOkClick"
            dialog-class="agent-member-list-wide"
            modal-class="agent-netenglish-modal agent-member-list-wide-modal">

            <!-- Modal Header -->
            <template #modal-header>
                <h5 class="modal-title">受講生一覧</h5>

                <div class="float-right w-25">
                    <div class="input-group">
                        <input type="search" class="form-control form-control-sm" placeholder="受講生を検索..."
                            aria-label="Search" v-model="searchQuery" @keyup.enter="handleSearch" />
                        <button class="btn btn-sm btn-primary px-2" @click="handleSearch">
                            <b-icon icon="search"></b-icon>
                        </button>
                    </div>
                </div>
            </template>

            <div v-if="isLoading == true" class="text-center py-5">
                <div class="spinner-border text-primary" role="status"></div>
            </div>

            <div v-if="isLoading == false">
                <div v-if="isSuccess == true" class="text-center">
                    <div class="alert alert-success" role="alert">
                        {{ this.message }}
                    </div>
                </div>

                <div class="table-responsive agent-member-list-table-scroll">
                <table class="table table-sm agent-member-list-table mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="small font-weight-bold">#</th>
                            <th scope="col" class="small font-weight-bold">お名前</th>
                            <th scope="col" class="small font-weight-bold text-center">ポイント</th>
                            <th scope="col" class="small font-weight-bold text-center col-self-book">
                                <span class="d-inline-flex align-items-center justify-content-center">
                                    本人予約を許可
                                    <span
                                        v-b-tooltip.hover="selfBookingTooltipOpts"
                                        class="ml-1 d-inline-flex align-items-center agent-self-booking-help"
                                        tabindex="0"
                                        role="button"
                                        aria-label="本人予約を許可について"
                                    >
                                        <b-icon icon="question-circle-fill" class="text-muted" font-scale="0.85" aria-hidden="true"></b-icon>
                                    </span>
                                </span>
                            </th>
                            <th scope="col" class="small font-weight-bold text-center col-fix-limit">固定予約の上限数</th>
                            <th scope="col" class="small font-weight-bold text-center">代理ログイン</th>
                            <th scope="col" class="small font-weight-bold text-center">レポート</th>
                            <th scope="col" class="small font-weight-bold text-center col-writing">ライティングレポート</th>
                            <th scope="col" class="small font-weight-bold text-center">履歴</th>
                            <th scope="col" class="small font-weight-bold text-center col-actions">操作</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-if="members.length === 0">
                            <td colspan="10" style="text-align: center;">
                                <div class="alert alert-danger my-3" role="alert">
                                    Sorry, No results found
                                </div>
                            </td>
                        </tr>

                        <tr :id="member.user_id" v-for="member in members" :key="member.user_id">

                            <th scope="row">{{ member.user_id }}</th>
                            <td>
                                <a href="#" @click="openMemberViewModal(member, $event)">
                                    {{ member.firstname }} {{ member.lastname }}
                                </a>
                            </td>
                            <td>
                                <span :id="'credit-' + member.user_id">{{ member.credits }}</span>
                            </td>


                            <td class="text-center">
                                <input
                                    type="checkbox"
                                    :checked="member.is_reservation_allowed"
                                    @change="handleReservationSettingCheckboxToggle(member.user_id, $event)"
                                />
                            </td>

                            <td>
                                <select class="form-control form-control-sm"
                                    :value="member.fix_reserve_limit_normal ?? 1"
                                    @change="handleFixReserveLimitNormalChange(member, $event)">
                                    <option :value="1">1件（通常）</option>
                                    <option :value="2">2件（通常）</option>
                                </select>
                            </td>

                            <!--
                            <td>
                                <input type="checkbox" :checked="member.is_customer_support_allowed"
                                    @change="handleCustomerSupportCheckboxToggle(member.user_id, $event)" />
                            </td>
                            -->

                            <td class="text-center text-success">
                                <b-button variant="outline-success" size="sm" @click="loginAs(member.user_id)"
                                    v-b-tooltip.hover="memberListTooltip('代理ログイン')" aria-label="代理ログイン">
                                    <b-icon icon="box-arrow-in-right" aria-hidden="true"></b-icon>
                                </b-button>
                            </td>



                            <td class="text-center text-success">
                                <b-button variant="outline-primary" size="sm" @click="viewReportCard(member.user_id)"
                                    v-b-tooltip.hover="memberListTooltip('レポートを見る')" aria-label="レポートを見る">
                                    <b-icon icon="card-heading" aria-hidden="true"></b-icon>
                                </b-button>
                            </td>

                            <td class="text-center text-success">
                                <b-button variant="outline-primary" size="sm"
                                    @click="viewWritingReportCard(member.user_id)"
                                    v-b-tooltip.hover="memberListTooltip('ライティングレポートを見る')" aria-label="ライティングレポートを見る">
                                    <b-icon icon="calculator" aria-hidden="true"></b-icon>
                                </b-button>
                            </td>

                            <td class="text-center text-success">
                                <b-button variant="outline-info" size="sm" @click="openMemberTransactionhistory(member)"
                                    v-b-tooltip.hover="memberListTooltip('レッスン履歴を見る')" aria-label="レッスン履歴を見る">
                                    <b-icon icon="clock-history" variant="primary" aria-hidden="true"></b-icon>
                                </b-button>
                            </td>


                            <td class="text-center text-success">

                                <b-button variant="outline-info" size="sm" @click="openMemberViewModal(member, $event)"
                                    v-b-tooltip.hover="memberListTooltip('受講生情報を見る')" aria-label="受講生情報を見る">
                                    <b-icon icon="eye" variant="info" aria-hidden="true"></b-icon>
                                </b-button>

                                <b-button variant="outline-info" size="sm" @click="openMemberEditModal(member, $event)"
                                    v-b-tooltip.hover="memberListTooltip('受講生情報を編集')" aria-label="受講生情報を編集">
                                    <b-icon icon="pencil-square" variant="success" aria-hidden="true"></b-icon>
                                </b-button>
                            </td>                            

                        </tr>
                    </tbody>
                </table>
                </div>

                <!-- [start] Pagination Controls -->
                <div v-if="lastPage > 1" class="pagination">
                    <button class="btn btn-sm mr-1">Page {{ currentPage }} of {{ lastPage }}</button>
                    <button @click="prevPage" :disabled="currentPage === 1"
                        class="btn btn-primary btn-sm mr-1">Previous</button>
                    <!-- Page Numbers -->
                    <button v-for="page in pageNumbers" :key="page" :class="{ active: currentPage === page }"
                        class="mr-1 btn btn-primary btn-sm" @click="goToPage(page)">
                        {{ page }}
                    </button>
                    <button @click="nextPage" :disabled="currentPage === lastPage"
                        class="btn btn-primary  btn-sm mr-1">Next</button>
                </div>
                <!-- [end] Pagination Controls -->

            </div>
        </b-modal>



        <!-- !! SEND MEMBER  CREDITS MODAL !! -->
        <b-modal id="sendMemberCreditsModal" title="受講生にポイントを付与" @ok="handleSendMemberCreditModalOkClick"
            ok-title="実行" cancel-title="キャンセル" size="lg" modal-class="agent-netenglish-modal">

            <div v-if="isUpdateCreditLoading == false">

                <div v-if="isUpdateCreditSuccess == true && this.message !== ''" class="text-center">
                    <div class="alert alert-success" role="alert">
                        {{ this.message }}
                    </div>
                </div>

                <div v-if="isUpdateCreditSuccess == false && this.message !== ''" class="text-center">
                    <div class="alert alert-danger" role="alert">
                        {{ this.message }}
                    </div>
                </div>


                <p class="text-muted small mb-3">
                    スクールアカウントの保有ポイントから、選択した受講生にポイントを付与します。受講生は、付与されたポイントを使ってレッスンを予約できます。
                </p>

                <!-- [START] AGENT INFO -->
                <div class="card card border-primary mb-3">
                    <div class="card-header text-white bg-primary">
                        スクールアカウントの保有ポイント
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-4 small">
                                現在の保有ポイント :
                            </div>
                            <div class="col-8 small">
                                {{ this.account.credits }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 small">
                                ポイント有効期限 :
                            </div>
                            <div class="col-8 small">
                                {{ this.account.creditsExpiration }}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- [END] AGENT INFO -->

                <!-- [START] SEND MEMBER CREDITS -->
                <div class="card card border-primary mb-3">
                    <div class="card-header text-white bg-primary">
                        受講生のポイント
                    </div>
                    <div class="card-body">
                        <b-form-group label-class="small" label="受講生" label-for="creditMemberSelect">
                            <b-form-select id="creditMemberSelect" v-model="selectedCreditMemberId"
                                :options="creditMemberOptions" size="sm" :disabled="isCreditMemberOptionsLoading"
                                @change="handleCreditMemberSelection">
                            </b-form-select>
                            <small v-if="isCreditMemberOptionsLoading" class="text-muted d-block mt-1">
                                受講生一覧を読み込み中です...
                            </small>
                            <small v-else-if="!selectedCreditMemberId" class="text-muted d-block mt-1">
                                先に受講生を選択してください。
                            </small>
                            <small v-if="memberSelectionError" class="text-danger d-block mt-1">
                                {{ memberSelectionError }}
                            </small>
                        </b-form-group>

                        <div class="row">

                            <div class="col-7">
                                <form @submit.prevent="submitMemberCreditForm">

                                    <b-form-select id="transactionType" v-model="form.transactionType"
                                        :options="transactionOptions" class="d-none" tabindex="-1"
                                        aria-hidden="true">
                                    </b-form-select>

                                    <b-form-group label-class="small" label="付与ポイント" label-for="credits"
                                        :invalid-feedback="formErrors.credits">

                                        <b-form-input type="text" id="credits" placeholder="ポイントを入力"
                                            v-model="form.credits" :state="formErrors.credits ? false : null" required
                                            size="sm" :disabled="!selectedCreditMemberId || isCreditMemberOptionsLoading"
                                            @input="filterCreditInput">
                                        </b-form-input>

                                    </b-form-group>

                                    <!--
                                    <b-form-group label-class="small" label="Expiry Date" label-for="expiryDate"
                                        :invalid-feedback="formErrors.expiryDate">
                                        <b-form-input type="date" id="expiryDate" placeholder="Enter expiry date"
                                            v-model="form.expiryDate" :state="formErrors.expiryDate ? false : null"
                                            required size="sm"
                                            :disabled="form.transactionOptions !== 'CREDITS_EXPIRATION'"
                                            @input="validateField('expiryDate')">
                                        </b-form-input>
                                    </b-form-group>
                                    -->

                                    <b-form-group label-class="small" label="備考" label-for="remarks">
                                        <b-form-textarea id="remarks" placeholder="備考を入力" v-model="form.remarks"
                                            rows="3" size="sm"
                                            :disabled="!selectedCreditMemberId || isCreditMemberOptionsLoading">
                                        </b-form-textarea>
                                    </b-form-group>


                                </form>


                            </div>
                            <div class="col-5">
                                <b-form-group label-class="small" label="受講生のポイント" label-for="credits">
                                    <b-form-input v-model="member.credits" readonly size="sm"></b-form-input>
                                </b-form-group>
                                <b-form-group label-class="small" label="最終購入日"
                                    label-for="latest_date_of_purchase">
                                    <b-form-input v-model="member.latest_date_of_purchase" readonly
                                        size="sm"></b-form-input>
                                </b-form-group>

                                <b-form-group label-class="small" label="ポイント有効期限"
                                    label-for="credits_expiration">
                                    <b-form-input v-model="member.formatted_credits_expiration" readonly
                                        size="sm"></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                </div>
                <!--[END] SEND MEMBER CREDITS -->


            </div>

            <div v-if="isUpdateCreditLoading == true" class="text-center my-4">
                <div class="spinner-border text-primary my-4" role="status">
                    <span class="visually-hidden"></span>
                </div>
            </div>

        </b-modal>

        <!-- !! SEND MEMBER CREDITS CONFIRMATION MODAL !! -->
        <b-modal id="sendMemberCreditsConfirmModal" title="確認" hide-header-close centered
            modal-class="agent-netenglish-modal" @hidden="creditGrantPreview = null">
            <template v-if="creditGrantPreview">
                <p class="mb-3">以下の内容でポイントを付与します。</p>
                <ul class="list-unstyled small mb-0 credit-grant-confirm-summary">
                    <li class="mb-2">受講生：{{ creditGrantPreview.memberName }}</li>
                    <li class="mb-2">付与ポイント：{{ creditGrantPreview.grantCredits }}ポイント</li>
                    <li class="mb-2">スクールアカウント残高：{{ creditGrantPreview.agentBefore }}ポイント → {{ creditGrantPreview.agentAfter }}ポイント</li>
                    <li>受講生ポイント：{{ creditGrantPreview.memberBefore }}ポイント → {{ creditGrantPreview.memberAfter }}ポイント</li>
                </ul>
            </template>
            <template #modal-footer>
                <b-button variant="secondary" size="sm" @click="cancelCreditConfirm" :disabled="isUpdateCreditLoading">
                    キャンセル
                </b-button>
                <b-button variant="primary" size="sm" @click="confirmCreditGrant" :disabled="isUpdateCreditLoading">
                    ポイントを付与する
                </b-button>
            </template>
        </b-modal>

        <!-- !! SEND MEMBER CREDITS COMPLETION / NEXT ACTIONS MODAL !! -->
        <b-modal id="sendMemberCreditsCompleteModal" title="完了" hide-header-close centered
            modal-class="agent-netenglish-modal" @hidden="creditGrantSuccessMember = null">
            <p class="mb-0">ポイントを付与しました。次に行う操作を選択してください。</p>
            <template #modal-footer>
                <div class="w-100 credit-grant-complete-actions">
                    <b-button variant="primary" size="sm" class="mb-2 btn-block w-100"
                        @click="handleCreditGrantReserveLesson">
                        この受講生のレッスンを予約する
                    </b-button>
                    <b-button variant="primary" size="sm" class="mb-2 btn-block w-100"
                        @click="handleCreditGrantFixReserve">
                        この受講生の固定予約を設定する
                    </b-button>
                    <b-button variant="secondary" size="sm" class="btn-block w-100"
                        @click="handleCreditGrantBackToList">
                        受講生一覧に戻る
                    </b-button>
                </div>
            </template>
        </b-modal>


    </div>
</template>




<script>
import AgentMemberViewerComponent from '../../backend/agent/MemberViewerComponent.vue';
import AgentMemberUpdateComponent from '../../backend/agent/AgentMemberUpdateComponent.vue';
import AgentBuyCreditComponent from '../../backend/agent/AgentBuyCreditComponent.vue';
import WritingReportCardComponent from '../../backend/agent/WritingReportCardComponent.vue';
import ReportCardComponent from '../../backend/agent/ReportCardComponent.vue';

export default {
    components: {
        AgentMemberUpdateComponent,
        AgentMemberViewerComponent,
        AgentBuyCreditComponent,
        WritingReportCardComponent,
        ReportCardComponent

    },
    props: {
        firstname: String,
        credits: Number,
        credits_expiration: String,
        latest_date_of_purchase: String,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {

            isLoading: false,
            isSuccess: false,
            message: '',

            //transaction
            isUpdateCreditLoading: false,
            isUpdateCreditSuccess: false,

            isSearched: false,
            searchQuery: '',


            currentPage: 1,
            lastPage: 1,
            perPage: 15, // Adjust per page if needed
            selectedCreditMemberId: null,
            memberSelectionError: null,
            isCreditMemberOptionsLoading: false,
            pageNumbers: [], // Array to store limited page numbers
            creditGrantPreview: null,
            creditGrantSuccessMember: null,


            //MEMBER TRANSACTION FORM
            form: {
                transactionType: null,
                credits: '',
                expiryDate: null
            },
            formErrors: {
                transactionType: null,
                credits: null,
                expiryDate: null
            },
            fieldNames: {
                transactionType: '取引種別',
                credits: '付与ポイント',
                expiryDate: '有効期限'
            },

            transactionOptions: [
                { value: null, text: '-- 取引種別を選択 --' },
                { value: 'MANUAL_ADD', text: '手動付与' },
                // { value: 'DISTRIBUTE', text: 'DISTRIBUTE' },
                { value: 'AGENT_SUBTRACT', text: '差引（スクールアカウント）' },
                //{ value: 'FREE_CREDITS', text: 'Free Credits' },
                //{ value: 'DISTRIBUTE', text: 'Distribute' },
                // { value: 'CREDITS_EXPIRATION', text: 'Credits Expiration' },
            ],

            creditRate: 1,

            //agent current accont info
            account: {
                credits: 0,
                dateOfPurchase: '',
                creditsExpiration: '',
            },

            //View Member Account Info
            member: {
                user_id: null,
                credits: 0,
                latest_date_of_purchase: '',
                formatted_credits_expiration: '',
            },

            members: [],
            creditMembers: [],
            creditMemberOptions: [
                { value: null, text: '-- 受講生を選択 --' }
            ],

            selfBookingTooltipOpts: {
                title: 'チェックを入れると、受講生本人がマイページからレッスン予約できるようになります。チェックを外すと、スクールアカウント側で予約を管理します。',
                container: 'body',
                boundary: 'window',
            },

        };
    },
    mounted() {

        //this.getAgentCredit(this.$props.agent_user_id);

        window.openAgentMemberList = this.openAgentMemberList;
        window.openCalendarReservationModal = this.openCalendarReservationModal;
        window.openAgentFixReserveModal = this.openAgentFixReserveModal;
        window.openBuyCreditsModal = this.openBuyCreditsModal;
        window.openSendMemberCreditsModal = (member) => this.openSendMemberCreditsModal(member);

        window.getAgentCredit = this.getAgentCredit;

        console.log(this.$props.latest_date_of_purchase, this.$props.credits_expiration)

        this.updateAccountInfo({
            credits: this.$props.credits ?? null,
            dateOfPurchase: this.$props.latest_date_of_purchase ?? null,
            creditsExpiration: this.$props.credits_expiration ?? null
        });

        
    },
    watch: {
        'form.credits': function (newCredits) {
            this.calculateTotalAmount(newCredits);
        }
    },
    methods: {

        memberListTooltip(title) {
            return {
                title,
                container: 'body',
                boundary: 'window',
            };
        },

        callOpenLoaderModal(message) {
            this.$refs.agentCalendarReservation.callOpenAgentLoaderModal(message);
        },
        callCloseLoaderModal() {
            this.$refs.agentCalendarReservation.callCloseAgentLoaderModal();
        },
        handleReservationSettingCheckboxToggle(user_id, event) {

            const newState = event.target.checked; // Get the toggled state

            axios.post("/api/updateMemberReservationSettings?api_token=" + this.api_token, {
                method: "POST",
                userID: user_id,
                settingValue: newState,
            }).then(response => {

                if (response.data.success === false) {
                    alert(response.data.message);
                } else {
                    //inform user
                }
            }).catch(function (error) {
                alert("Error " + error);
            });
        },
        handleCustomerSupportCheckboxToggle(user_id, event) {

            const newState = event.target.checked; // Get the toggled state


            axios.post("/api/updateMemberCustomerSupportSettings?api_token=" + this.api_token, {
                method: "POST",
                userID: user_id,
                settingValue: newState,
            }).then(response => {

                if (response.data.success === false) {
                    alert(response.data.message);
                } else {
                    //inform user
                }
            }).catch(function (error) {
                alert("Error " + error);
            });

        },

        handleFixReserveLimitNormalChange(member, event) {
            const newValue = parseInt(event.target.value, 10);
            if (![1, 2].includes(newValue)) {
                alert("Invalid fix reserve limit value");
                return;
            }

            axios.post("/api/updateMemberFixReserveLimitNormal?api_token=" + this.api_token, {
                method: "POST",
                userID: member.user_id,
                settingValue: newValue,
            }).then(response => {
                if (response.data.success === false) {
                    alert(response.data.message);
                } else {
                    member.fix_reserve_limit_normal = newValue;
                    this.$forceUpdate();
                }
            }).catch(function (error) {
                alert("Error " + error);
            });
        },


        viewReportCard(memberID) {
            this.$refs.reportCard.openReportCard(memberID);
        },

        viewWritingReportCard(memberID) {
            this.$refs.writingReportCard.openWritingReportCard(memberID);
        },

        reset() {
            this.isLoading = false;
            this.isSuccess = false;

            this.isUpdateCreditLoading = false;
            this.isUpdateCreditSuccess = false;


            this.message = '';

            this.form = {
                transactionType: 'MANUAL_ADD',
                credits: '',
                expiryDate: null,
                //totalAmount: '0.00'               
            }

            this.formErrors = {
                transactionType: null,
                credits: null,
                expiryDate: null
            }

            this.memberSelectionError = null;
        },
        createEmptyMember() {
            return {
                user_id: null,
                credits: 0,
                latest_date_of_purchase: '',
                formatted_credits_expiration: '',
            };
        },
        filterCreditInput(event) {
            // Restrict input to only numeric values (integers)
            this.form.credits = this.form.credits.replace(/[^0-9]/g, '');

            // Optionally call your validation method here
            this.validateField('credits');
        },
        validateForm() {
            let isValid = true;
            // Validate all fields in the form
            Object.keys(this.form).forEach((field) => {
                if (!this.validateField(field)) {
                    isValid = false;
                }
            });
            return isValid;
        },
        validateField(fieldName) {

            this.$set(this.formErrors, fieldName, null);
            const value = this.form[fieldName];

            if (fieldName === "expiryDate" && this.form.transactionType !== "CREDITS_EXPIRATION") {
                return true;
            }

            if (fieldName === 'transactionType') {
                return true;
            }

            if (!value) {
                this.$set(this.formErrors, fieldName, `${this.fieldNames[fieldName]} is required`);
                return false;
            }

            // Email-specific validation
            if (fieldName === 'email') {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(value)) {
                    this.$set(this.formErrors, fieldName, 'Please enter a valid email address');
                    return false;
                }
            }


            // Expiry Date validation only if transactionType is "CREDITS_EXPIRATION"
            if (fieldName === 'expiryDate' && this.form.transactionType === 'CREDITS_EXPIRATION') {
                if (!value) {
                    this.$set(this.formErrors, fieldName, `${this.fieldNames[fieldName]} is required`);
                    return false;
                }
            }

            return true;
        },
        calculateTotalAmount(credits) {
            const creditsValue = parseFloat(credits);
            if (!isNaN(creditsValue) && creditsValue > 0) {
                // Format the calculated amount to two decimal places
                this.form.totalAmount = (creditsValue * this.creditRate).toFixed(2);
            } else {
                this.form.totalAmount = '0.00'; // Reset to a formatted string if invalid input
            }
        },
        openBuyCreditsModal() {
            //alert ("buy credits modal");
            this.$bvModal.show('openBuyCreditsModal');
            this.$refs.agentBuyCredits.openBuyCreditsModal();
        },
        handleModalOkClick($event) {
            // Prevent the modal from closing when the OK button is pressed
            $event.preventDefault();  // This prevents the default close behavior of the modal
            this.submitBuyCreditForm();        // Call your form submission logic
        },

        //!! MEMBER LIST !!
        openAgentMemberList($event) {
            this.getMemberList();
        },
        handleModalMemberListOkClick($event) {
            this.$bvModal.hide('openAgentMemberList');
        },
        goToPage(num) {
            console.log("page?? ", num)
            this.getMemberList(num);
        },
        nextPage() {
            if (this.currentPage < this.lastPage) {
                this.getMemberList(this.currentPage + 1);
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.getMemberList(this.currentPage - 1);
            }
        },

        handleSearch() {
            this.isSearched = true;
            this.getMemberList(1);
        },

        getMemberList(page = 1, showModal = true) {
            this.isLoading = true;
            this.currentPage = page;
            this.members = [];

            this.callOpenLoaderModal("受講生一覧を読み込み中です...");

            axios.post("/api/get_agent_member_list?api_token=" + this.api_token, {
                method: "POST",
                agent_user_id: this.$props.agent_user_id,
                page: this.currentPage,
                per_page: this.perPage,
                searchQuery: this.searchQuery
            }).then(response => {
                this.callCloseLoaderModal();
                if (showModal) {
                    this.$bvModal.show('openAgentMemberList');
                }
                this.isLoading = false;
                if (response.data.success === false) {
                    alert(response.data.message);
                    this.callCloseLoaderModal();
                } else {
                    this.members = response.data.memberlist.data;
                    this.lastPage = response.data.memberlist.last_page;

                    this.updatePageNumbers();
                }

            }).catch(function (error) {

                this.callCloseLoaderModal();

                this.isLoading = false;
                alert("Error " + error);
            });
        },
        updatePageNumbers() {

            const maxPagesToShow = 15; // Max number of pages to show
            const halfRange = Math.floor(maxPagesToShow / 2);

            // Adjust start and end page to make sure they are within bounds
            let startPage = this.currentPage - halfRange;
            let endPage = this.currentPage + halfRange;

            // Ensure start page is at least 1
            if (startPage < 1) {
                startPage = 1;
                endPage = Math.min(maxPagesToShow, this.lastPage); // Make sure endPage doesn't exceed lastPage
            }

            // Ensure end page doesn't exceed lastPage
            if (endPage > this.lastPage) {
                endPage = this.lastPage;
                startPage = Math.max(1, this.lastPage - maxPagesToShow + 1); // Make sure startPage doesn't go below 1
            }

            // Generate the list of page numbers to display
            this.pageNumbers = [];

            for (let i = startPage; i <= endPage; i++) {
                this.pageNumbers.push(i);
            }

        },
        //!! SEND MEMBER MODAL BELOW !!
        clearMemberCreditForm() {
            this.reset();
        },
        async loadCreditMembers() {
            this.isCreditMemberOptionsLoading = true;

            const creditMembers = [];
            let page = 1;
            let lastPage = 1;

            try {
                do {
                    const response = await axios.post("/api/get_agent_member_list?api_token=" + this.api_token, {
                        method: "POST",
                        agent_user_id: this.$props.agent_user_id,
                        page: page,
                        per_page: 100,
                        searchQuery: ''
                    });

                    if (response.data.success === false) {
                        throw new Error(response.data.message);
                    }

                    const currentMembers = response.data.memberlist.data || [];
                    creditMembers.push(...currentMembers);
                    lastPage = response.data.memberlist.last_page || 1;
                    page += 1;
                } while (page <= lastPage);

                this.creditMembers = creditMembers;
                this.creditMemberOptions = [
                    { value: null, text: '-- 受講生を選択 --' },
                    ...creditMembers.map((member) => ({
                        value: member.user_id,
                        text: `${member.firstname} ${member.lastname} (ID: ${member.user_id})`
                    }))
                ];
            } catch (error) {
                this.message = error.response?.data?.message || error.message || ('Error ' + error);
                this.isUpdateCreditSuccess = false;
            } finally {
                this.isCreditMemberOptionsLoading = false;
            }
        },
        handleCreditMemberSelection(memberId) {
            this.memberSelectionError = null;

            const selectedMember = this.creditMembers.find((member) => String(member.user_id) === String(memberId));
            this.member = selectedMember ? { ...selectedMember } : this.createEmptyMember();
        },
        async openSendMemberCreditsModal(member = null) {
            this.clearMemberCreditForm();
            this.member = this.createEmptyMember();
            this.selectedCreditMemberId = null;
            this.$bvModal.show('sendMemberCreditsModal');

            await this.loadCreditMembers();

            if (member && member.user_id) {
                this.selectedCreditMemberId = member.user_id;
                this.handleCreditMemberSelection(member.user_id);
            }
        },
        closeSendMemberCreditsModal() {
            this.$bvModal.hide('sendMemberCreditsConfirmModal');
            this.$bvModal.hide('sendMemberCreditsCompleteModal');
            this.$bvModal.hide('sendMemberCreditsModal');
            this.clearMemberCreditForm();
            this.member = this.createEmptyMember();
            this.selectedCreditMemberId = null;
            this.creditGrantPreview = null;
            this.creditGrantSuccessMember = null;
        },
        dismissCreditGrantCompleteModal() {
            this.$bvModal.hide('sendMemberCreditsCompleteModal');
            this.clearMemberCreditForm();
            this.member = this.createEmptyMember();
            this.selectedCreditMemberId = null;
            this.creditGrantPreview = null;
            this.creditGrantSuccessMember = null;
        },
        handleCreditGrantReserveLesson() {
            const memberUserId = this.creditGrantSuccessMember
                ? this.creditGrantSuccessMember.user_id
                : null;
            this.dismissCreditGrantCompleteModal();
            this.openCalendarReservationModal(memberUserId);
        },
        handleCreditGrantFixReserve() {
            const memberUserId = this.creditGrantSuccessMember
                ? this.creditGrantSuccessMember.user_id
                : null;
            this.dismissCreditGrantCompleteModal();
            if (this.$refs.agentFixReserve && memberUserId) {
                this.$refs.agentFixReserve.openAgentFixReserveModalForMember(memberUserId);
            } else {
                this.openAgentFixReserveModal();
            }
        },
        handleCreditGrantBackToList() {
            this.dismissCreditGrantCompleteModal();
            this.openAgentMemberList();
        },


        openMemberTransactionhistory(member) {
            this.$refs.memberTransactionHistory.openMemberTransactionHistory(member);
        },
        openCalendarReservationModal(memberUserId = null) {
            this.$refs.agentCalendarReservation.openCalendarReservationModal(memberUserId);
        },
        openAgentFixReserveModal() {
            if (this.$refs.agentFixReserve) {
                this.$refs.agentFixReserve.openAgentFixReserveModal();
            }
        },
        getSelectedMemberName() {
            if (this.member && (this.member.firstname || this.member.lastname)) {
                return `${this.member.firstname || ''} ${this.member.lastname || ''}`.trim();
            }

            const option = this.creditMemberOptions.find(
                (item) => String(item.value) === String(this.selectedCreditMemberId)
            );

            return option ? option.text : '';
        },
        buildCreditGrantPreview() {
            const grantCredits = parseInt(this.form.credits, 10) || 0;
            const agentBefore = parseInt(this.account.credits, 10) || 0;
            const memberBefore = parseInt(this.member.credits, 10) || 0;

            if (this.form.transactionType === 'AGENT_SUBTRACT') {
                return {
                    memberName: this.getSelectedMemberName(),
                    grantCredits,
                    agentBefore,
                    agentAfter: agentBefore + grantCredits,
                    memberBefore,
                    memberAfter: memberBefore - grantCredits,
                };
            }

            return {
                memberName: this.getSelectedMemberName(),
                grantCredits,
                agentBefore,
                agentAfter: agentBefore - grantCredits,
                memberBefore,
                memberAfter: memberBefore + grantCredits,
            };
        },
        handleSendMemberCreditModalOkClick($event) {
            $event.preventDefault();

            this.isUpdateCreditSuccess = false;
            this.message = '';
            this.memberSelectionError = null;

            if (!this.member || !this.member.user_id) {
                this.memberSelectionError = '受講生を選択してください';
                this.message = '受講生を選択してください';
                return;
            }

            if (!this.validateForm()) {
                this.message = '必須項目を入力してください';
                return;
            }

            const grantCredits = parseInt(this.form.credits, 10) || 0;
            if (grantCredits <= 0) {
                this.$set(this.formErrors, 'credits', '付与ポイントを入力してください');
                return;
            }

            this.creditGrantPreview = this.buildCreditGrantPreview();
            this.$bvModal.show('sendMemberCreditsConfirmModal');
        },
        cancelCreditConfirm() {
            this.$bvModal.hide('sendMemberCreditsConfirmModal');
        },
        confirmCreditGrant() {
            this.$bvModal.hide('sendMemberCreditsConfirmModal');
            this.isUpdateCreditLoading = true;
            this.isUpdateCreditSuccess = false;
            this.updateAgentCredit(this.$props.agent_user_id, this.member, this.form);
        },
        safeValue(value) {
            return value === null || value === undefined ? null : value;
        },
        updateAccountInfo(data) {

            //Account Info updates all Agent and Member;
            this.account.credits = this.safeValue(data.credits);
            this.account.dateOfPurchase = this.safeValue(data.dateOfPurchase);
            this.account.creditsExpiration = this.safeValue(data.creditsExpiration);

            this.member.credits = this.safeValue(data.memberCredits);
            this.member.latest_date_of_purchase = this.safeValue(data.memberDateOfPurchase);
            this.member.formatted_credits_expiration = this.safeValue(data.memberCreditsExpiration);

            this.$forceUpdate();
        },
        updateAgentInfo(data) {
            this.updateAccountInfo(data);
        },
        getAgentCredit(agentID) {
            axios.post("/api/getAgentCredits?api_token=" + this.api_token, {
                method: "POST",
                agentID: agentID
            }).then(response => {
                if (response.data.success === true) {
                    let data = response.data
                    this.updateAccountInfo(data);
                } else {
                    this.message = response.data.message;
                }
            });
        },
        updateAgentCredit(agentID, member, formData) {
            axios.post("/api/updateAgentCredits?api_token=" + this.api_token, {
                method: "POST",
                agentID: agentID,
                member: member,
                form: formData
            }).then(response => {

                this.isUpdateCreditLoading = false;
                this.isUpdateCreditSuccess = false;

                if (response.data.success === true) {
                    let data = response.data
                    this.updateAccountInfo(data);
                    this.updateMemberCredit();
                } else {
                    this.message = response.data.message;
                }
            });
        },
        updateMemberCredit() {
            axios.post("/api/updateMemberCredits?api_token=" + this.api_token, {
                method: "POST",
                agent_user_id: this.$props.agent_user_id,
                form: this.form,
                member: this.member
            }).then(response => {

                if (response.data.success === false) {

                    this.isUpdateCreditLoading = false;
                    this.isUpdateCreditSuccess = false;
                    this.message = response.data.message;

                } else {

                    this.message = response.data.message;
                    this.isUpdateCreditLoading = false;
                    this.isUpdateCreditSuccess = true;

                    this.form.totalAmount = this.form.credits;
                    this.getMemberList(this.currentPage, false);
                    this.handleCreditMemberSelection(this.selectedCreditMemberId);

                    this.creditGrantSuccessMember = { ...this.member };
                    this.$bvModal.hide('sendMemberCreditsConfirmModal');
                    this.$bvModal.hide('sendMemberCreditsModal');
                    this.$bvModal.show('sendMemberCreditsCompleteModal');
                }
            }).catch(function (error) {
                alert("Error " + error);
            });
        },

        loginAs(memberID) {
            // Get the current authenticated user's ID
            localStorage.setItem('agent_user_id', this.$props.agent_user_id);

            //window.location.href = '/admin/login-user/' + memberID;

                const form = document.createElement('form');
                form.method = 'POST';
                form.action = '/admin/login-user';

                const csrf = document.querySelector('meta[name="csrf-token"]');
                if (csrf) {
                    const csrfInput = document.createElement('input');
                    csrfInput.type = 'hidden';
                    csrfInput.name = '_token';
                    csrfInput.value = csrf.getAttribute('content');
                    form.appendChild(csrfInput);
                }

                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'member_id';
                input.value = memberID;
                form.appendChild(input);

                document.body.appendChild(form);
                form.submit();

        },

        openMemberViewModal(member, event) {
            this.$refs.agentMemberViewer.openViewMemberModal(member);
            event.preventDefault();           
        },

        openMemberEditModal(member, event) {
            this.$refs.agentMemberUpdate.openAgentMemberUpdateModal(member);
             event.preventDefault();      
        },
        onMemberUpdate() {

            console.log("update member on page : ", this.currentPage);
            this.getMemberList(this.currentPage);
            
        }

    },
    watch: {
        searchQuery(newValue) {
            // If searchQuery becomes empty, trigger the search
            if (newValue === '' && this.isSearched == true) {
                this.getMemberList(1);
                this.isSearched = false;
            }
        }
    }
};
</script>

<style scoped>
.agent-info-card {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e5e7eb !important;
}

.agent-info-card-header {
    background: linear-gradient(135deg, #009de2, #19a5fc);
    font-weight: 700;
    font-size: 0.9375rem;
    padding: 0.65rem 1rem;
    border-bottom: none;
}

.agent-info-card-body {
    padding: 1rem 1.1rem;
    background: #fafbfc;
}

.agent-info-grid {
    display: grid;
    grid-template-columns: minmax(0, 38%) 1fr;
    gap: 0.5rem 0.75rem;
    align-items: baseline;
    font-size: 0.8125rem;
}

.agent-info-label {
    color: #6b7280;
    font-weight: 600;
    line-height: 1.35;
}

.agent-info-value {
    color: #111827;
    font-weight: 500;
    line-height: 1.35;
    word-break: break-word;
}

.agent-info-value.agent-info-muted {
    font-size: 0.78rem;
    color: #4b5563;
}

.agent-info-credits {
    font-weight: 700;
    font-size: 0.9375rem;
    color: #19a5fc;
}

.agent-info-description {
    line-height: 1.5;
}

@media (max-width: 399.98px) {
    .agent-info-grid {
        grid-template-columns: 1fr;
    }

    .agent-info-label {
        margin-top: 0.35rem;
    }

    .agent-info-label:first-child {
        margin-top: 0;
    }
}
</style>

<style>
/* 受講生一覧 — wider modal + single-line headers (modal is teleported) */
.modal.agent-member-list-wide-modal .modal-dialog.agent-member-list-wide {
    max-width: min(96vw, 1380px);
    width: 96vw;
    margin: 1.75rem auto;
}

.agent-member-list-table thead th {
    white-space: nowrap;
    vertical-align: middle;
    padding: 0.5rem 0.45rem;
    line-height: 1.2;
}

.agent-member-list-table thead th.col-writing {
    min-width: 9.5rem;
}

.agent-member-list-table thead th.col-self-book {
    min-width: 7.5rem;
}

.agent-member-list-table thead th.col-fix-limit {
    min-width: 8.5rem;
}

.agent-member-list-table thead th.col-actions {
    min-width: 5.5rem;
}

.agent-member-list-table tbody td,
.agent-member-list-table tbody th {
    vertical-align: middle;
}

.agent-member-list-table-scroll {
    margin-bottom: 0;
    overflow-x: visible;
}

.agent-self-booking-help {
    cursor: help;
}

/* Tooltips must sit above Bootstrap modal (1050) */
body > .tooltip,
body > .b-tooltip {
    z-index: 1100 !important;
}

@media (max-width: 767.98px) {
    .agent-member-list-table-scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .agent-member-list-table {
        min-width: 1100px;
    }
}
</style>